import { gpHome } from '../app';
import { IAuthService } from '../services/auth-service';
import { CurrentUserService, ISubscriptionStatus } from '../../app-common/services/current-user-service';
import { AppSettings } from '../app-settings';
import { IAuthorisationStatus } from '../../app-common/services/authorisation-checker-with-caching-service';

interface IIndexToolbarControllerScope extends ng.IScope {
    subscription: ISubscriptionStatus;
    logOut: () => void;
    authorisation: IAuthorisationStatus;
    isNavActive: (path: string) => boolean;
}

gpHome.controller('indexToolbarController', [
    '$scope',
    '$location',
    'authService',
    '$interval',
    CurrentUserService.serviceName,
    function ($scope: IIndexToolbarControllerScope, $location: ng.ILocationService, authService: IAuthService, $interval: ng.IIntervalService, currentUserService: CurrentUserService) {

        function getLicenseNoThrow() {
            try {
                currentUserService.getSubscriptionStatus().then(subscription => {
                    $scope.subscription = subscription;
                }).catch(err => { });
            } catch (ex) {
            }
        }

        $interval(() => getLicenseNoThrow(), 1000 * 60 * 5);

        // A section owns its sub-routes too, e.g. '/plans' stays active on
        // '/plans/new'.
        $scope.isNavActive = (path: string) => {
            const current = $location.path() || '/';
            return current === path || current.indexOf(path + '/') === 0;
        };

        $scope.logOut = function () {
            authService.logOut();
            // we do this so we don't see a flicker of a login screen while the page reloads.
            AppSettings.hideLoginUntilRefresh = true;
            $location.path('/login');

            window.location.reload();
        }

        authService.authorisationChanged(authStatus => {
            getLicenseNoThrow();
            $scope.authorisation = authStatus;
        });

    }]);
